module.exports = __webpack_public_path__ + "img/verifikasi_top_up.cc3beab5.svg";